import { Component } from '@angular/core';
import { StructuredDataOrganizationInterface, StructuredDataPersonInterface } from "./models";
import { StructuredDataAbstractComponent } from "./structured-data.abstract.component";

@Component({
  selector: 'gea-shop-structured-data-organization',
  templateUrl: './structured-data.component.html',
  styleUrls: [],
  standalone: false
})
export class StructuredDataOrganizationComponent extends StructuredDataAbstractComponent {
  protected generateJsonLd(): [ StructuredDataPersonInterface, StructuredDataOrganizationInterface ] {
    return [{
      "@context": "https://schema.org",
      "@type": "Person",
      "@id": '#person-heinrich-staudinger',
      name: "Heinrich Staudinger",
      gender: "https://schema.org/Male",
      givenName: "Heinrich",
      familyName: "Staudinger",
      alternateName: "Heini Staudinger",
      image: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f0/B%C3%BCrgerrechtstattBankenrechtWien04_%28cropped%29.jpg/197px-B%C3%BCrgerrechtstattBankenrechtWien04_%28cropped%29.jpg",
      brand: { "@id": "#gea-organization" },
      birthDate: "1953-04-05",
      birthPlace: {
        "@context": "https://schema.org",
        "@type": "Place",
        name: "Vöcklabruck"
      }
    }, {
      "@context": "https://schema.org",
      "@type": "Organization",
      "@id": "#gea-organization",
      url: "https://gea-waldviertler.at/",
      logo: "https://gea-waldviertler.at/shop/assets/logo-gea.png",
      name: "GEA Waldviertler",
      image: "https://gea-waldviertler.at/media/images/GESCHICHTE_1140X450.width-1800.jpegquality-80.jpg",
      legalName: "Waldviertler Werkstätten GmbH",
      description: "Wir produzieren Taschen, Schuhe, Möbel, betreiben eine Akademie, ein Hotel und ein Restaurant. Alles Aufgaben, die früher in einem Dorf arbeitsteilig organisiert waren. Und jetzt wo die Ortsstrukturen weitgehend kaputt sind, wollen wir Verantwortung übernehmen, unseren Lebensraum selbst zu gestalten. Das, was wir hier ausprobieren, ist nicht immer leicht. Wenn es glückt, ist es wahnsinnig beglückend. Der Arbeiter in der Schuhfabrik, EDV-Experten, Kursleiter in der Akademie und Kommunikations-Experten - sie alle agieren hier in enger Zusammenarbeit.",
      email: "gea@gea.at",
      telephone: "+43-2853-76503",
      address: {
        "@context": "https://schema.org",
        "@type": "PostalAddress",
        streetAddress: "Niederschremser Straße 4b",
        addressLocality: "Schrems",
        addressCountry: "AT",
        addressRegion: "Niederösterreich",
        postalCode: "3943"
      },
      vatID: "ATU 18027506",
      hasMerchantReturnPolicy: this.generateMerchantReturnPolicyJsonLd(true),
      founder: { "@id": "#person-heinrich-staudinger" }
    }]
  }
}
